import { Link } from 'react-router-dom';
import { SEOHead } from '@/components/SEOHead';
import { Breadcrumbs } from '@/components/Breadcrumbs';

export const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-background" data-testid="privacy-page">
      <SEOHead
        title="Privacy Policy"
        description="Privacy Policy of 12 Jyotirlingas.info - how we collect, use, and protect your information when you visit our pilgrimage guide website."
        keywords="privacy policy, data protection, jyotirlinga, cookies"
        canonical="https://jyotirlinga.info/privacy-policy"
      />
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl">
          <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Privacy Policy' }]} />
          <h1 className="font-cormorant text-4xl sm:text-5xl font-bold tracking-tighter text-temple-slate mt-8 mb-8">
            Privacy Policy
          </h1>
          <div className="font-outfit text-gray-700 space-y-6 leading-relaxed">
            <p className="text-sm text-gray-500">Last updated: {new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })}</p>

            <p>Welcome to <strong>Jyotirlinga.info</strong> ("we", "our", "us"). This Privacy Policy explains how we collect, use, and protect your personal information when you visit our website dedicated to the 12 sacred Jyotirlinga temples of Lord Shiva.</p>

            <h2 className="font-cormorant text-2xl font-bold text-temple-slate mt-8">1. Information We Collect</h2>
            <p>We may collect the following types of information:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Usage data:</strong> pages visited, time spent, referring URL, device and browser type (via Google Analytics).</li>
              <li><strong>Cookies:</strong> small text files that enable website functionality and analytics.</li>
              <li><strong>Contact information:</strong> only when you voluntarily submit it via our Contact page.</li>
            </ul>

            <h2 className="font-cormorant text-2xl font-bold text-temple-slate mt-8">2. How We Use Your Information</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>To improve website content and user experience</li>
              <li>To respond to your queries submitted via the Contact page</li>
              <li>To display relevant advertisements through Google AdSense</li>
              <li>To measure the effectiveness of our content via Google Analytics</li>
            </ul>

            <h2 className="font-cormorant text-2xl font-bold text-temple-slate mt-8">3. Google AdSense & Cookies</h2>
            <p>We use Google AdSense to display advertisements. Google uses cookies (including the DoubleClick cookie) to serve ads based on your visits to this and other websites. You can opt out of personalized advertising by visiting <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer" className="text-saffron-600 hover:underline">Google Ads Settings</a>.</p>

            <h2 className="font-cormorant text-2xl font-bold text-temple-slate mt-8">4. Affiliate Disclosure</h2>
            <p>Our site contains affiliate links to Amazon India (as an Amazon Associate), Booking.com, Agoda, IndiGo Hotels, and Cleartrip via Cuelinks. When you make purchases through these links, we may earn a commission — at no extra cost to you. This helps us keep the Jyotirlinga guide free and updated.</p>

            <h2 className="font-cormorant text-2xl font-bold text-temple-slate mt-8">5. Third-Party Services</h2>
            <p>We use the following third-party services that may collect information:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Google Analytics (usage tracking)</li>
              <li>Google AdSense (advertising)</li>
              <li>Amazon Associates (affiliate program)</li>
              <li>OpenStreetMap (interactive temple map)</li>
            </ul>

            <h2 className="font-cormorant text-2xl font-bold text-temple-slate mt-8">6. Data Security</h2>
            <p>We take reasonable measures to protect your information but cannot guarantee absolute security. All communication with our site is encrypted via HTTPS.</p>

            <h2 className="font-cormorant text-2xl font-bold text-temple-slate mt-8">7. Your Rights</h2>
            <p>You have the right to request access to, correction of, or deletion of your personal data. Contact us via the <Link to="/contact" className="text-saffron-600 hover:underline">Contact page</Link>.</p>

            <h2 className="font-cormorant text-2xl font-bold text-temple-slate mt-8">8. Children's Privacy</h2>
            <p>Our website is not directed to children under 13. We do not knowingly collect information from children.</p>

            <h2 className="font-cormorant text-2xl font-bold text-temple-slate mt-8">9. Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated date.</p>

            <h2 className="font-cormorant text-2xl font-bold text-temple-slate mt-8">10. Contact Us</h2>
            <p>If you have any questions about this Privacy Policy, please contact us via our <Link to="/contact" className="text-saffron-600 hover:underline">Contact page</Link>.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
